/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ amount: NonNullable<unknown> }} Seat_Change_Confirm_PayInputs */



/**
* | output |
* | --- |
* | "Pay {amount} and change" |
*
* @param {Seat_Change_Confirm_PayInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const seat_change_confirm_pay = /** @type {((inputs: Seat_Change_Confirm_PayInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Seat_Change_Confirm_PayInputs, { locale?: "en" | "de" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ (`${i?.amount} bezahlen und ändern`)
	return /** @type {LocalizedString} */ (`Pay ${i?.amount} and change`)
});